module.exports = __webpack_public_path__ + "img/toolbar_recharge.3ec583ce.png";